import { render, staticRenderFns } from "./CustomerUnLock.vue?vue&type=template&id=5f5d38ac"
import script from "./CustomerUnLock.vue?vue&type=script&lang=js"
export * from "./CustomerUnLock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports